import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import ServicePlugin from './plugins/service'
import router from './router'
import store from './store'
import '@/assets/global.styl'
import Vant from 'vant'
import 'vant/lib/index.css'
import service from './service'
import '@/components'
import 'amfe-flexible'
import '@/assets/resetVui.css'
import VueWechatTitle from 'vue-wechat-title'
import utils from './utils'
import constants from './utils/utils'
import api from './http/index'
// main.js
// import wx from 'weixin-js-sdk'
// import axios from 'axios'
import clipboard from 'clipboard'

import './vconsole'

;(async function () {
  // 接口中入参有一个url，直接取location.href.split('#')[0]
  // let jsApiList = [
  //   'onMenuShareTimeline',
  //   'onMenuShareAppMessage',
  //   'chooseImage',
  //   'previewImage'
  // ]
  // const uri = process.env.VUE_APP_TITLE === 'production' ? '/' : '/api/'

  // const res1 = await axios.get(`${uri}mall/v1/store/info`, {})
  // const appid = res1.data.data.appId
  // let res2 = await axios.get(`${uri}wx-server/util/js/api/ticket`, {
  //   params: {
  //     appId: appid,
  //     url: location.href.split('#')[0]
  //   }
  // })
  // const data = res2.data.data
  // wx.config({
  //   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  //   appId: appid, // 必填，公众号的唯一标识
  //   timestamp: data.timestamp, // 必填，生成签名的时间戳
  //   nonceStr: data.nonceStr, // 必填，生成签名的随机串
  //   signature: data.signature, // 必填，签名，见附录1
  //   jsApiList: jsApiList, // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
  //   openTagList: ['wx-open-launch-weapp']
  // })
  // wx.checkJsApi({
  //   jsApiList: jsApiList, // 需要检测的JS接口列表，所有JS接口列表见附录2,
  //   openTagList: ['wx-open-launch-weapp'],
  //   success: res => {
  //     console.log('检查jsapi', JSON.stringify(res))
  //   }
  // })
})()

Vue.prototype.clipboard = clipboard
Vue.prototype.$constants = constants
Vue.use(utils)
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.use(ServicePlugin)
Vue.use(VueRouter)
Vue.use(Vant)
// Vue.prototype.$wx = wx
// 忽略标签检测
// Vue.config.ignoredElements = ['wx-open-launch-weapp']

Vue.use(api)

service.init(state => {
  new Vue({
    service,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
